import { ICountry } from '@libs/interfaces';
//
export enum DEVICE {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
}
export enum DEVICE_TYPE {
  TABLET = 'tablet',
  DESKTOP = 'desktop',
  ANDROID = 'android',
  IPHONE = 'iphone',
  IPAD = 'ipad',
}
export interface IDevice {
  browser: string;
  browser_version: string;
  device: string;
  device_id: string;
  deviceType: DEVICE;
  iOS: boolean;
  isDesktop: boolean;
  isMobile: boolean;
  isTablet: boolean;
  orientation: 'portrait' | 'landscape';
  os: string;
  userAgent: string;
  // geoip: IGeoip;
  ip: string;
  os_version: string;
  isIphone: boolean;
  isIpad: boolean;
  screen: {
    maxTouchPoints: number;
    width: number;
    height: number;
  };
}
export interface IGeoip {
  area: number;
  city: string;
  country: ICountry;
  eu: string;
  ll: number[];
  metro: number;
  range: number[];
  region: string;
  timeZone: string;
}
